import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=08ef8eb9&"
import script from "./CompanySearch.vue?vue&type=script&lang=js&"
export * from "./CompanySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ef8eb9')) {
      api.createRecord('08ef8eb9', component.options)
    } else {
      api.reload('08ef8eb9', component.options)
    }
    module.hot.accept("./CompanySearch.vue?vue&type=template&id=08ef8eb9&", function () {
      api.rerender('08ef8eb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/CompanySearch.vue"
export default component.exports